import React from 'react';

export interface RadioState<T> {
  groupName?: string;
  selectedValue?: T;
  onChangeSelected?: (value: T) => unknown;
}

export const RadioContext = React.createContext<RadioState<any>>({});
RadioContext.displayName = 'RadioContext';
